<template>
  <div v-show="getProject.name" class="fade-in navbar-container">
    <nav class="navbar columns is-mobile" role="navigation" aria-label="main navigation">
      <div class="text-center absolute-header">
        <h1>{{dynamicHeader}}</h1>
      </div>
      <div class="navbar-brand">
        <a class="flex">
            <icon class="top-bar-svg fill-niras-red" name="niraslogo"></icon>
        </a>
      </div>
      <div class="navbar-start column flex-align-center">
        <a class="navbar-item flex-align-center" @click="setShowProjectModal(true)">
          <div class="project-title">
            <span>{{getProject.name}}</span>
          </div>
          <div class="project-author">
            <span>{{getProject.author}}</span>
          </div>
          <!-- <div class="project-create-date">
            <span>
              {{getProject.createdDate}}
            </span>
          </div> -->
        </a>
        <div class="navbar-end flex-align-center">
          <div class="navbar-item save-button-container">
            <button v-if="currentState === 'results'" class="flex-align-center button pdf-button" @click="makePDF()">
              <icon class="small-svg fill-white flex" name="pdf-file"></icon>
              <span>{{$t('top-bar.export')}}</span>
            </button>
            <button class="flex-align-center button save-button" @click="setShowSaveModal(true)">
              <icon class="small-svg fill-white flex" name="cloud-download"></icon>
              <span>{{$t('top-bar.saveButton')}}</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'top-bar',
  computed: {
    ...mapGetters({
      getProject: 'getProject',
      currentState: 'getCurrentState'
    }),
    dynamicHeader () {
      if (this.currentState === 'goals') {
        return this.$t('goals.pageTitle')
      }
      if (this.currentState === 'targets') {
        return this.$t('targets.pageTitle')
      }
      if (this.currentState === 'results') {
        return this.$t('results.pageTitle')
      }
      return ''
    }
  },
  methods: {
    ...mapActions({
      setCreatePDF: 'setCreatePDF',
      setShowSaveModal: 'setShowSaveModal',
      setShowProjectModal: 'setShowProjectModal'
    }),
    makePDF () {
      this.setCreatePDF(true)
    }
  }
}
</script>
